import React, { useState, useEffect/* , useReducer */ } from 'react';
import { Drawer, Button, Form, Row, Col, InputNumber } from 'antd';
import { AutoCompleteServico } from '../auto-complete/AutoCompleteServico';
import { InputDinheiro } from '../Numeros/input-dinheiro';
import {  SwapOutlined } from '@ant-design/icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTools } from '@fortawesome/pro-duotone-svg-icons';
import './AddServico.scss';
import {  Dinheiro } from '..';
import { useServicos } from '../../services/useServicos';
import { usePedido } from '../../services/usePedidos';
import { useSelector, useDispatch } from 'react-redux';
//import {reducerServicosTypes, defaultStateServicos, reducerServicos} from '../../../store/reducer-servicos';
//import {reducerPedidoTypes, defaultState, reducerPedido} from '../../../store/reducer-pedido';


const getWidth = () => {
    const w = window.innerWidth;
    if (w <= 768) {
        return w;
    }
    return 400;
}

const AddServico = ({ close, visible, title }) => {
    const [servicoSelecionado, setServicoSelecionado] = useState();
    const [totalServico, setTotalServico] = useState(0);
    const [totalDesconto, setTotalDesconto] = useState(0);
    const [inputDesconto, setInputDesconto] = useState(0);
    const [inputValor, setInputValor] = useState(0);
    const [inputQuantidade, setInputQuantidade] = useState(1);

    const { atualizaPedido } = usePedido();
    const {  servicoXPedido } = useServicos();
    //const [servicos,dispatchServicos] = useReducer(reducerServicos, defaultStateServicos);
    const reducerServicos = useSelector((state) => state.reducerServicos);
    const servicos = reducerServicos.servicos;
    //const [statePedido,dispatchPedido] = useReducer(reducerPedido,defaultState);
    const reducerPedido = useSelector((state) => state.reducerPedido);
    const pedido = reducerPedido.pedido;
    const dispatch = useDispatch();

    /*  useEffect(() => {
         if (servicoSelecionado?.valor) {
             setTotalServico(servicoSelecionado.valor);
         }
     }, [servicoSelecionado?.valor]) */

    useEffect(() => {
        calculaTotalDesconto()
    })

    const calculaTotalDesconto = () => {
        var vartotalServico = (parseFloat(inputValor)*parseFloat(inputQuantidade)) - parseFloat(inputDesconto);
        setTotalDesconto(inputDesconto);
        setTotalServico(vartotalServico);
    }

    const handleSelect = (selected, option) => {
        console.log("selected", selected);
        console.log("option", option)
        option.valor = parseFloat(option.valor);
        setServicoSelecionado(option);
        setInputValor(option.valor)
        /* setValor(option.valor); */
    }

    const changeDesconto = function (value) {
        setInputDesconto(value);
    }

    const changeValor = function (value) {
        setInputValor(value);
    }

    const changeQuantidade = function(value){
        setInputQuantidade(value);
    }

    const desenhaServicoSelecionado = () => {
        if (servicoSelecionado && servicoSelecionado !== null) {
            return <>
                <Form.Item name="quantidade" label="Quantidade">
                    <InputNumber onChange={changeQuantidade} value={inputQuantidade} defaultValue={1} />
                </Form.Item>
                <Form.Item name="valor" label="Valor">
                    <InputDinheiro size="large" onChangeValue={changeValor} value={inputValor} initialValue={servicoSelecionado.valor} />
                </Form.Item>
                <Form.Item name="desconto" label="Desconto">
                    <InputDinheiro size="large" onChangeValue={changeDesconto} value={inputDesconto} /* initialValue={servicoSelecionado.desconto} */ />
                </Form.Item>
                <Row gutter={16} className="totais">
                    <Col span={12} className="totalProduto">
                        <span className="label">
                            Total Produto
                        </span>
                        <Dinheiro className="total" value={inputValor}></Dinheiro>
                    </Col>
                    <Col span={12} className="totais">
                        <span className="label">
                            Total Item
                        </span>
                        <Dinheiro className="total" value={totalServico} ></Dinheiro>
                    </Col>
                </Row>
            </>
        }
    }

    const changeServico = () => {
        setServicoSelecionado(null)
    }

    /* const calculaTotais = (data) => {
        
        data.totalDescontos += totalDesconto;
        data.totalServicos += totalServico;
        
        return data;
    } */

    const atualizaTotalPedido = async () => {
        var novoPedido = pedido;

        novoPedido.totalPedido += totalServico;
        novoPedido.totalDescontos += totalDesconto;
        novoPedido.totalServicos = totalServico;
        novoPedido.servicos = servicos;
        var result = await atualizaPedido(novoPedido);
        if (result?.uuid) {
            dispatch({ type: reducerPedido.reducerPedidoTypes.SET_PEDIDO, payload: result });
        }
    }

    const addServicoXPedido = async () => {
        var data = {
            uuidPedido: pedido.uuid,
            descricaoServico: servicoSelecionado.descricao,
            valorServico: servicoSelecionado.valor,
            totalDescontos: totalDesconto,
            totalServico: totalServico,
            uuidServico: servicoSelecionado.uuid,
            quantidade: inputQuantidade
        }


        //data = calculaTotais(data);

        var result = await servicoXPedido(data);

        //var arrayServicos = servicos;
        //arrayServicos.push(data);
        await dispatch({ type: reducerServicos.reducerServicosTypes.SET_SERVICOS, payload: result });

        await atualizaTotalPedido();

        close();
        changeServico();
        if (result?.uuid) {
            close();
        }
    }

    return (
        <Form layout="vertical" className="formProduto" >
            <Drawer
                title={title}
                visible={visible}
                onClose={close}
                width={getWidth()}
                footer={
                    <div style={{ textAlign: 'right' }}>
                        <Button type="default">Cancelar</Button>&nbsp;
                        <Button type="primary" htmlType="submit" onClick={addServicoXPedido}>Adicionar</Button>
                    </div>
                }
            >

                {
                    (!servicoSelecionado) ?

                        <Form.Item name="servico" label="Serviço">
                            <AutoCompleteServico handleSelect={handleSelect}>

                            </AutoCompleteServico>
                        </Form.Item>
                        :
                        <Form.Item name="servico" label="Serviço">
                            <FontAwesomeIcon
                                size="5x"
                                icon={faTools}>
                            </FontAwesomeIcon>
                            <span style={{ marginLeft: "10px", textTransform: "capitalize" }}>{servicoSelecionado.descricao}</span>
                            <a href style={{ float: "right", color: "red" }} onClick={changeServico}><SwapOutlined /> Trocar</a>
                        </Form.Item>

                }
                {desenhaServicoSelecionado()}


            </Drawer>
        </Form>
    )
}

export { AddServico }